import * as Actions from 'app/store/actions'
import { compose } from 'ramda'
import { networkErrorToMessage } from 'commons/error'

const showError = ({ message, duration = 5000 }) =>
  Actions.showMessage({
    message: message, //text or html
    autoHideDuration: duration, //ms
    anchorOrigin: {
      vertical: 'top', //top bottom
      horizontal: 'center', //left center right
    },
    variant: 'error', //success error info warning null
  })

const showSuccess = ({ message }) =>
  Actions.showMessage({
    message: message, //text or html
    autoHideDuration: 5000, //ms
    anchorOrigin: {
      vertical: 'top', //top bottom
      horizontal: 'center', //left center right
    },
    variant: 'success', //success error info warning null
  })

const showWarning = ({ message }) =>
  Actions.showMessage({
    message: message, //text or html
    autoHideDuration: 5000, //ms
    anchorOrigin: {
      vertical: 'top', //top bottom
      horizontal: 'center', //left center right
    },
    variant: 'warning', //success error info warning null
  })

const showNetworkError = (formatMessage) =>
  compose(showError, networkErrorToMessage(formatMessage))

export default {
  showError,
  showSuccess,
  showWarning,
  showNetworkError,
}
